module.exports = __webpack_public_path__ + "static/media/W00F0002.1f66c8f6.svg";